import { Theme } from '@mui/material';

export default {
	styleOverrides: {
		root: ({ theme }: { theme: Theme }) => ({
			padding: '10px 8px',
			marginBlock: '8px',
			[theme.breakpoints.up('sm')]: {
				width: '200px',
				marginBlock: '4px',
			},
		}),
		monthButton: {
			width: '100%',
			height: '46px',
			margin: '0px',
			borderRadius: '8px',
		},
	},
};
